<template>
  <div id="app" :class="['theme_'+$store.state.theme]">
    <!-- <div id="app" class="theme_0"> -->
    <router-view class="body" v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {

      reloads: this.reloads
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    getUserSkin() {
      this.$ajax.get(process.env.API_HOST + "skintype/userSkin").then((res) => {
        if (res && res.status == 200) {
          if (res.data.code == 0) {
            let userSkin = res.data.data;
            if (userSkin) {
              this.$store.state.theme = userSkin.skinNo;
            }
          }
        }
      });
    },
    reloads() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted: function () {
    //  this.getUserSkin();
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue